// Client calls to the admin API endpoints (server validates an immutable-user-id allowlist).
import { supabase, isSupabaseConfigured } from './supabaseClient';

const authedFetch = async (path, options = {}) => {
    if (!isSupabaseConfigured) throw new Error('Accounts are not configured.');
    const { data: { session } = {} } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) throw new Error('Please sign in.');

    const response = await fetch(path, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            ...(options.headers || {})
        }
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || 'Request failed.');
    return payload;
};

export const getAdminStatus = () => authedFetch('/api/admin/status');

export const runDailyGeneration = (daysAhead = 3) =>
    authedFetch('/api/admin/run-daily', { method: 'POST', body: JSON.stringify({ daysAhead }) });

export const savePromptSetting = (kind, setting) =>
    authedFetch('/api/admin/prompt-settings', {
        method: 'PUT',
        body: JSON.stringify({ kind, ...setting })
    });

const adminService = { getAdminStatus, runDailyGeneration, savePromptSetting };

export default adminService;
